<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import type { SpacerSize } from '../types';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			size: SpacerSize;
			desktop_size?: SpacerSize;
		}>['content'];
	}

	let { content }: Props = $props();

	let desktopSize = $derived(content.desktop_size || content.size);
</script>

<div
	use:editable={content}
	class={[
		'pointer-events-none',
		{
			hidden: content.size === 'none',
			'mt-[var(--full-header-height)] transition-[margin-top] duration-300': content.size === 'nav',
			'transition-[margin-top] duration-300 lg:mt-[var(--full-header-height)]':
				desktopSize === 'nav',
			'lg:hidden': desktopSize === 'none',
			'mt-2': content.size === 'XS',
			'lg:mt-3': desktopSize === 'XS' || desktopSize === 'small',
			'mt-3': content.size === 'small',
			'mt-5': content.size === '20',
			'lg:mt-5': desktopSize === '20',
			'mt-6': content.size === 'medium',
			'lg:mt-6': desktopSize === 'medium',
			'mt-7': content.size === '28',
			'lg:mt-7': desktopSize === '28',
			'mt-8': content.size === '32',
			'lg:mt-8': desktopSize === '32' || desktopSize === 'S',
			'mt-9': content.size === '36',
			'lg:mt-9': desktopSize === '36',
			'mt-10': content.size === '40',
			'lg:mt-10': desktopSize === '40',
			'lg:mt-12': desktopSize === 'large',
			'mt-14': content.size === '56',
			'mt-20': content.size === '80',
			'mt-[100px]': content.size === '100',
			'mt-[114px]': content.size === '114',
			'lg:mt-14': desktopSize === '56',
			'lg:mt-20': desktopSize === '80',
			'mt-4': content.size === 'S',
			'mt-12': content.size === 'M' || content.size === 'large',
			'mt-16': content.size === 'L',
			'lg:mt-16': desktopSize === 'M',
			'lg:mt-32': desktopSize === 'L',
			'lg:mt-[100px]': desktopSize === '100',
			'lg:mt-[114px]': desktopSize === '114'
		}
	]}
></div>
